import React from 'react';
import { Form, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ModeComponent from '../../ModeComponent';

export default class ShopTime extends ModeComponent {
  static propTypes = {
    activeStory: PropTypes.bool.isRequired,
  };

  // properties set on each mount
  clockType = 'mechanics';
  defaultFocus = 'causeInput';
  mode = 'ST';

  schema = {
    causeInput: {
      label: 'Cause',
      multiline: true,
    },
    correctionInput: {
      label: 'Correction',
      multiline: true,
    },
  };

  state = {
    causeInput: {
      value: '',
      validationState: null,
    },
    correctionInput: {
      value: '',
      validationState: null,
    },
  };
  // end properties reset on each mount

  constructor(props) {
    super(props);

    // patch schema to remove required fields if story not active
    if (!props.activeStory) {
      this.schema.causeInput.required = false;
      this.schema.correctionInput.required = false;
    }
  }

  render() {
    return (
      <Card className="success">
        <Card.Header>
          <Card.Title>Action Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form
            onSubmit={e => {
              e.preventDefault();
            }}
          >
            {this.props.activeStory && this.validatedTextInput('causeInput')}
            {this.props.activeStory && this.validatedTextInput('correctionInput')}
            {!this.props.activeStory && (
              <div style={{ fontSize: '16px', textAlign: 'center' }}>No additional action details required.</div>
            )}
          </Form>
        </Card.Body>
      </Card>
    );
  }
}
